import {menu} from './menu';
import {axiosCancel} from './axiosCancel';


export interface IAppStore {
  axiosCancel: ReturnType<typeof axiosCancel>;
  menu: ReturnType<typeof menu>;
}

const appStore: IAppStore = {} as IAppStore;

export const registerStore = () => {
  appStore.axiosCancel = axiosCancel();
  appStore.menu = menu();
};
export default appStore;
